import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const TIERS = [{
  id: 1,
  name: 'THE SCHOOLYARD',
  emoji: '🌟',
  color: 'bg-blue-500',
  borderColor: 'border-blue-500',
  textColor: 'text-blue-400',
  desc: 'Clean, family-friendly disappointment. Like a disappointed dad at a little league game.',
  quote: "Oh buddy... the Hinge Hunters tried their absolute best! We're all winners when we have fun! (But you lost by 40) 🌟"
}, {
  id: 2,
  name: 'THE LOCKER ROOM',
  emoji: '🏟️',
  color: 'bg-slate-400',
  borderColor: 'border-slate-400',
  textColor: 'text-slate-300',
  desc: 'PG-13 rowdy. HR might want a word, but they cannot fire you for it.',
  quote: "Hinge Hunters got absolutely pantsed on national television. Josh Allen put up 23... for the OTHER team. Go sit in the corner and think about what you've done."
}, {
  id: 3,
  name: 'GOOD OLD BOYS',
  emoji: '🍺',
  color: 'bg-green-700',
  borderColor: 'border-green-600',
  textColor: 'text-green-500',
  desc: 'R-rated. Third beer in at a hunting cabin. Zero filter, maximum emotional damage.',
  quote: 'Boy, I seen better roster management from a blindfolded raccoon in a dumpster fire. What in the sweet name of Sam Hill were you thinkin startin a backup tight end?'
}, {
  id: 4,
  name: 'THE ROAST',
  emoji: '🔥',
  color: 'bg-crimson',
  borderColor: 'border-crimson',
  textColor: 'text-crimson',
  desc: 'Full Tom Brady Netflix roast. We will make you question why you even like football.',
  quote: 'LOCKED — Our lawyers said we literally cannot put this quote on a public website. Unlock at checkout. 🔥',
  isLocked: true
}];
export const HilariousMeter = () => {
  const [activeTier, setActiveTier] = useState(3);
  return <div className="w-full max-w-6xl mx-auto" data-id="element-319">
      {/* Visual Dial / Meter */}
      <div className="mb-16 relative pt-8 px-4" data-id="element-320">
        <div className="h-4 bg-dark rounded-full border border-white/10 overflow-hidden relative" data-id="element-321">
          <motion.div className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-500 via-green-500 to-crimson" initial={false} animate={{
          width: `${activeTier / 4 * 100}%`
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} data-id="element-322" />
        </div>

        {/* Dial Indicator */}
        <motion.div className="absolute top-4 w-8 h-8 bg-white rounded-full border-4 border-charcoal shadow-[0_0_15px_rgba(255,255,255,0.5)] z-10 flex items-center justify-center" initial={false} animate={{
        left: `calc(${activeTier / 4 * 100}% - 16px)`
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} data-id="element-323">
          <div className="w-2 h-2 bg-charcoal rounded-full" data-id="element-324" />
        </motion.div>

        <div className="flex justify-between mt-4 text-xs font-bold uppercase tracking-wider text-slate" data-id="element-325">
          <span data-id="element-326">Mild Disappointment</span>
          <span data-id="element-327">Emotional Devastation</span>
        </div>
      </div>

      {/* Cards Row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-12" data-id="element-328">
        {TIERS.map(tier => <button key={tier.id} onClick={() => setActiveTier(tier.id)} className={`relative text-left p-6 rounded-2xl border-2 transition-all duration-300 flex flex-col ${activeTier === tier.id ? `${tier.borderColor} bg-dark shadow-[0_0_30px_rgba(0,0,0,0.5)] scale-105 z-10` : 'border-white/10 bg-charcoal hover:border-white/30 opacity-70 hover:opacity-100'}`} data-id="element-329">
            <div className="mb-4 flex items-center justify-between" data-id="element-330">
              <span className={`text-xs font-bold uppercase tracking-wider ${tier.textColor}`} data-id="element-331">
                Tier {tier.id}
              </span>
              <span className="text-2xl" data-id="element-332">{tier.emoji}</span>
            </div>
            <h3 className="font-heading font-black text-2xl mt-1 mb-2" data-id="element-333">
              {tier.name}
            </h3>
            <p className="text-sm text-slate mb-6 flex-1" data-id="element-334">{tier.desc}</p>

            <div className="mt-auto" data-id="element-335">
              <span className={`w-full block text-center py-2 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors ${activeTier === tier.id ? tier.color + ' text-white' : 'bg-white/5 text-white/50'}`} data-id="element-336">
                Select This Chaos
              </span>
            </div>

            {/* Active Indicator */}
            {activeTier === tier.id && <motion.div layoutId="activeIndicator" className={`absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 rotate-45 ${tier.color}`} data-id="element-337" />}
          </button>)}
      </div>

      {/* Quote Display */}
      <div className="relative max-w-3xl mx-auto" data-id="element-338">
        <AnimatePresence mode="wait" data-id="element-339">
          <motion.div key={activeTier} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className={`p-8 rounded-3xl border-2 bg-dark text-center relative overflow-hidden ${TIERS[activeTier - 1].borderColor}`} data-id="element-340">
            <div className={`absolute inset-0 opacity-10 ${TIERS[activeTier - 1].color}`} data-id="element-341"></div>

            <div className="relative z-10" data-id="element-342">
              <p className="text-sm font-bold uppercase tracking-wider mb-4 text-slate" data-id="element-343">
                What this sounds like
              </p>

              {TIERS[activeTier - 1].isLocked ? <div className="py-8" data-id="element-344">
                  <p className="text-2xl md:text-4xl font-heading font-black italic blur-sm select-none text-white/50" data-id="element-345">
                    "This is way too explicit to show on a public marketing
                    website."
                  </p>
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-346">
                    <span className="bg-crimson text-white px-6 py-3 rounded-full font-bold uppercase tracking-wider shadow-xl flex items-center gap-2" data-id="element-347">
                      🔒 {TIERS[activeTier - 1].quote}
                    </span>
                  </div>
                </div> : <p className="text-2xl md:text-4xl font-heading font-black italic text-white leading-tight" data-id="element-348">
                  "{TIERS[activeTier - 1].quote}"
                </p>}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
};